import { getEnvironmentConfig, ttmsDataProvider } from "@tt/ttms-react-core";
import { GetListParams, GetListResult, useDataProvider } from "react-admin";
import * as config from "./config";

const envConfig = getEnvironmentConfig(config);
if (!envConfig.api.baseUrl.startsWith("https://")) {
  throw new Error("Base URL must use HTTPS.");
}
const dataProvider = ttmsDataProvider(envConfig.api.baseUrl);
const { http, baseUrl } = dataProvider;

const appDataProvider = {
  ...dataProvider,
  // async getPopularVideos(): Promise<GetListResult<any>> {
  //   return http.get(`${baseUrl}/videos/getpopularvideos`);
  // },
  async getList(resource: string, params: GetListParams): Promise<GetListResult<any>> {
    if (resource === "videounitreports") {
      if (!params.filter?.videoId__eq) {
        return {
          data: [],
          total: 0,
        };
      }
      return dataProvider.getList(resource, params);
    }
    return dataProvider.getList(resource, params);
  },
};

export default appDataProvider;
export type AppDataProvider = typeof appDataProvider;
export const useAppDataProvider = (): AppDataProvider => useDataProvider() as any;
